import { Box, IconButton } from "@origin-digital/ods-core";
import React from "react";
import { IconProfile } from "@origin-digital/ods-icons";
import { useAuth0 } from "src/hooks/useAuth";
import { ContextMenu, ContextMenuItem } from "src/components/ContextMenu";

export const ProfileMenuButton: React.FC<{
  consumerAnchorEl?: HTMLElement | null;
}> = (props) => {
  const { logout } = useAuth0();
  return (
    <Box
      backgroundColor="grey100"
      display="inline-flex"
      style={{ borderRadius: "100%" }}
    >
      <ContextMenu
        consumerAnchorEl={props.consumerAnchorEl}
        iconButton={
          <IconButton
            id="profile-icon-button"
            aria-label="Settings"
            aria-controls={"profile-menu"}
            aria-haspopup="true"
          >
            <IconProfile color="neutral" size="xsmall" />
          </IconButton>
        }
        menuProps={{
          MenuListProps: {
            "aria-labelledby": "profile-icon-button",
          },
        }}
      >
        <ContextMenuItem onHandleClick={() => logout()}>
          Log out
        </ContextMenuItem>
      </ContextMenu>
    </Box>
  );
};
